import { FC } from 'react';
import { Flex, Text, HStack, IconButton } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { IoSparklesSharp } from 'react-icons/io5';
import { useRealtimeChatContext } from '../hooks/useRealtimeChatContext';
import { useRightSidebarContext } from 'src/contexts/app/RightSidebarContext';
import { NewChatButton } from './NewChatButton';

interface IHeader {
	height?: string | number;
}

/**
 * Fusion Copilot Header Component
 *
 * IMPORTANT: This header is used on MOBILE devices only (hidden on desktop)
 * Desktop uses AccordionTab component instead (see RightSidebar.tsx)
 *
 * Display logic in FusionCopilot index.tsx:
 * <Box display={{ base: 'block', md: 'none' }}>
 *   <Header />
 * </Box>
 */
const Header: FC<IHeader> = ({ height = '60px' }) => {
	const { closeCopilot } = useRealtimeChatContext();
	const { handleCloseSidebar } = useRightSidebarContext();

	const handleClose = () => {
		closeCopilot();
		handleCloseSidebar();
	};

	return (
		<Flex
			height={height}
			bg="white"
			align="center"
			px={4}
			py={2}
			justifyContent="space-between"
			borderBottomWidth={1}
			position="sticky"
			w="full"
			zIndex={100}
			top={0}
			boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
		>
			<Flex color="orange.base" gap={2} alignItems="center">
				<IoSparklesSharp style={{ width: '24px', height: '24px' }} />
				<Text
					color="orange.base"
					overflow="hidden"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
					fontSize="18px"
					fontWeight="600"
				>
					Fusion Copilot
				</Text>
			</Flex>
			<HStack gap={2} spacing={2}>
				{/* Reusable "Start new chat" button - see NewChatButton.tsx */}
				<NewChatButton size="sm" variant="solid" />
				<IconButton
					aria-label="Close copilot"
					icon={<ChevronRightIcon />}
					variant="unstyled"
					onClick={handleClose}
					fontSize={28}
				/>
			</HStack>
		</Flex>
	);
};

export default Header;
